import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Image } from '@fiverr-private/media';
import { BriefDrawer } from '@fiverr-private/ai_brief';
import {
    selectRecipientInfo,
    useStaticContext,
    selectBriefData, shouldShowBrief,
    selectEventSource
} from '../../../../context/contexts/static';
import { useReporting } from '../../../../hooks';
import { BRIEF_BUTTON_IS_CLICKED, BRIEF_BUTTON_IS_SHOWN } from '../../../../constants/biEvents';
import AiImage from './ai.svg';

import style from './style.module.scss';

const COMPONENT_NAME = 'contact_seller_drawer';

export const GenerateBrief = ({ onClose }) => {
    const context = useStaticContext();
    const [isShowDrawer, setIsShowDrawer] = useState(false);
    const [isDrawerLoading, setIsDrawerLoading] = useState(false);
    const source = selectEventSource(context);
    const { sendBiEvent, sendMixpanelEvent } = useReporting();

    const isBriefShown = useMemo(() => shouldShowBrief(context), [context]);

    const {
        username: userName,
        displayName,
        sellerId,
        responseTimeInHrs: responseTime
    } = selectRecipientInfo(context);
    const { categoryId, subCategoryId } = selectBriefData(context) || {};

    const closeDrawer = () => {
        setIsShowDrawer(false);
        setIsDrawerLoading(false);
        onClose();
    };

    const openDrawer = () => {
        setIsDrawerLoading(true);
        setIsShowDrawer(true);
        sendMixpanelEvent({ type: BRIEF_BUTTON_IS_CLICKED, params: { source: 'send_message_package' } });
    };

    useEffect(() => {
        if (isBriefShown && categoryId && subCategoryId) {
            sendBiEvent({ type: BRIEF_BUTTON_IS_SHOWN, params: { categoryId, subCategoryId } });
        }
    }, [isBriefShown, sendBiEvent, categoryId, subCategoryId]);

    if (!isBriefShown) {
        return null;
    }

    return (
        <div className={style.generateBriefContainer}>
            <div className={style.aiImageText}>
                <Image src={AiImage} width={41} height={38} alt="ai"/>
                <span className={style.question}>
                    <I18n k={'send_message.brief.title'}/>
                </span>
            </div>
            <Button variant="outline"
                size="sm"
                className={style.cta}
                loading={isDrawerLoading}
                onClick={openDrawer}>
                <I18n k={'send_message.brief.cta'}/>
            </Button>
            <BriefDrawer shouldRefreshData={isShowDrawer}
                categoryId={categoryId}
                componentName={COMPONENT_NAME}
                source={source}
                subCategoryId={subCategoryId}
                isOpen={isShowDrawer && !isDrawerLoading}
                onClose={closeDrawer}
                onLoadingChange={setIsDrawerLoading}
                seller={{
                    id: Number(sellerId),
                    userName,
                    displayName,
                    responseTime
                }}/>
        </div>
    );
};

GenerateBrief.propTypes = {
    onClose: PropTypes.func
};
